import React, { Component } from 'react'
import { DragSource } from 'react-dnd';
import BigCalendar from 'react-big-calendar'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

/* drag sources */
const itemSource = {
    beginDrag(props) {
        return props.item;
    },
    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        let target = monitor.getDropResult()

        switch(props.base_view)
        {
            case('module_schedule'):
            {
                return props.onDrop(props.item, target.week, target.day, props.module_id, target.dayValue)
            }
            case('course_builder_unscheduled'):
            {
               return props.onDrop(props.item, target.DisplayOrder)
            }
            default:
            {
                null
            }
        }

        
        return true
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}

class DraggableExpansionPanel extends Component {

    render() {
        let { connectDragSource, isDragging } = this.props;
        let EventWrapper = BigCalendar.components.eventWrapper;
        // The EventWrapper allows it to be dropped on to ReactBigCalendar
        if (this.props.alreadySelected) {
            return (
                <div style={{ opacity: isDragging ? 0.5 : 1 }}>
                    <ExpansionPanel style={{ backgroundColor: 'lightgrey' }} >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{this.props.itemName}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Typography>
                                {this.props.expansionInfo}
                                </Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
            )
        }

        return (
            <EventWrapper>
                {connectDragSource(
                    <div style={{ opacity: isDragging ? 0.5 : 1 }}>
                        <ExpansionPanel style={{ backgroundColor: this.props.alreadySelected ? '#DDDDDD' : 'white' }} >
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>{this.props.itemName}</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Typography>
                                    {this.props.expansionInfo}
                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </div>)}
            </EventWrapper>
        );
    }
}

export default DragSource('item', itemSource, collectSource)(DraggableExpansionPanel);


// WEBPACK FOOTER //
// src/main/components/dragAndDrop/DraggableExpansionPanel.js